var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view_box",class:_vm.isAni ? 'ani':''},[_c('div',{staticClass:"title"},[_vm._v("避免流失Tips")]),_c('div',{staticClass:"text_font"},[_vm._v("防患于未然—及时进行关怀&促活")])])
}
var staticRenderFns = []

export { render, staticRenderFns }